import { toWSDateString } from "@wingspanhq/fe-component-library";
import {
  FILLING_CODE_OPTIONS,
  INCOME_ESTIMATE_OPTIONS,
  US_STATES_OPTIONS
} from "../../constants/user";
import { Quarter } from "@wingspanhq/utils/dist/date/taxDeadlines";
import { TaxQuarter } from "@wingspanhq/bookkeeping/dist/lib/interfaces/taxEstimate";

export function formatFilingCode(filingCode?: string) {
  return FILLING_CODE_OPTIONS.find(option => option.value === filingCode)
    ?.label;
}

export function formatIncomeEstimate(incomeEstimate?: number) {
  return INCOME_ESTIMATE_OPTIONS.find(option => option.value === incomeEstimate)
    ?.label;
}

export function formatStateOfResidence(stateOfResidence?: string) {
  return US_STATES_OPTIONS.find(option => option.value === stateOfResidence)
    ?.label;
}
/**
 * Formats an internal deadline Date as "Mon DD, YYYY at 9:00 AM EST".
 * The time is hardcoded because the upstream `getTaxPaymentInternalDeadline`
 * always sets the deadline to 9:00 AM ET, but `toWSDateString` would render
 * the hour in the user's local timezone — causing the displayed time to be
 * wrong for anyone outside Eastern Time.
 */
export const formatInternalDeadline = (deadline: Date): string =>
  `${toWSDateString(deadline, "monthDayYear")} at 9:00 AM EST`;

export const QUARTER_TO_TAX_QUARTER: Record<Quarter, TaxQuarter> = {
  [Quarter.Q1]: TaxQuarter.q1,
  [Quarter.Q2]: TaxQuarter.q2,
  [Quarter.Q3]: TaxQuarter.q3,
  [Quarter.Q4]: TaxQuarter.q4
};
